/**
 * Portal Manta · featuresDoExtra
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { BANCO_CHUVA_UF } from '../../data/banco-chuva-uf.js';

function featuresDoExtra(extra){
  const ext = extra.ext || 1;
  const pu = extra.pu || {};
  const uf = extra.uf || 'PR';
  const chuva = BANCO_CHUVA_UF[uf] || {mm:1500,dias:100,regime:'Regular'};
  return {
    sig: extra.id, nome: extra.nome || 'Extra', sigla: extra.sigla || 'X', fonte:'extra',
    ext: extra.ext||0, dupKm: extra.dupKm||0, margKm: extra.margKm||0, fxKm: extra.fxKm||0,
    ciclKm: extra.ciclKm||0, oaeQt: extra.oaeQt||0, passQt: extra.passQt||0,
    interQt: extra.interQt||0, sicroTotal: extra.custoTotal||0,
    densDup: ext>0?(extra.dupKm||0)/ext:0, densMarg: ext>0?(extra.margKm||0)/ext:0,
    densCicl: ext>0?(extra.ciclKm||0)/ext:0, densOae: ext>0?(extra.oaeQt||0)/ext:0,
    densInter: ext>0?(extra.interQt||0)/ext:0,
    pu: {
      dup: pu.dup||0, marg: pu.marg||0, fx: pu.fx||0, cicl: pu.cicl||0,
      oae: pu.oae||0, pass: pu.pass||0, inter: pu.inter||0,
      sicroPorKm: ext>0?(extra.custoTotal||0)/ext:0,
    },
    uf, regiao: UF_REGIAO[uf]||'Sul', cidade: extra.cidade||'',
    ctxRural: extra.ctxRural ?? 0.6, ctxUrbano: extra.ctxUrbano ?? 0.2, ctxSerra: extra.ctxSerra ?? 0.2,
    chuvaMM: extra.chuvaMM ?? chuva.mm, chuvaDias: extra.chuvaDias ?? chuva.dias, chuvaRegime: extra.chuvaRegime ?? chuva.regime,
  };
}

export { featuresDoExtra };
export default featuresDoExtra;
